import FormSection from 'components/shared/Form/FormSection';
import FormStep from 'components/shared/Form/FormStep';
import SectionLoader from 'components/shared/SectionLoader';
import { useFormikContext } from 'formik';
import GenericFormSection from '../GenericFormSection/GenericFormSection';
import { useFetchDealTypes } from '../hooks';
import { DealTypeKeys } from '../types';
import { getDealTypeKey } from '../utils';
import { sections } from './data';
import useFetchDropdowns from './useFetchDropdowns';

const Step2 = () => {
  const { values } = useFormikContext<any>();
  const { dealTypes, loading: loadingDealTypes } = useFetchDealTypes();
  const { dropdowns, loading: loadingDropdowns } = useFetchDropdowns(values.dealTypeId);

  if (loadingDropdowns || loadingDealTypes) return <SectionLoader />;
  if (!dealTypes || dealTypes.length === 0) {
    return <SectionLoader />;
  }

  const key = getDealTypeKey(values.dealTypeId, dealTypes) as DealTypeKeys;

  return (
    <FormStep>
      {sections.map(({ title, shouldShow, fields }) => {
        if (shouldShow && !shouldShow(key)) {
          return null;
        }

        return (
          <FormSection title={title} key={title}>
            <GenericFormSection
              dropdowns={dropdowns}
              fields={typeof fields === 'function' ? fields(key) : fields}
            />
          </FormSection>
        );
      })}
    </FormStep>
  );
};

export default Step2;
